import { useFormat } from '@ideavivat/vivat-2';

function filterValueToQuery(filter: any, initialPrefix = '') {
  if (!filter) return '';
  let result = '';
  Object.entries(filter).forEach(([key, value]: any[]) => {
    if (typeof filter[key] !== 'object' && Array.isArray(filter[key])) {
      // In case of recent variable is type of Array, then loop through whole array element;
      // eslint-disable-next-line
      filter[key].forEach((elm: any) => {
        // If inside of Array is object, call nested;
        if (typeof elm === 'object' && !(Array.isArray(elm))) result = filterValueToQuery(elm);
        // if not just added;
        result = `${result}&${key}[]=${elm}`;
      });
    } else if (typeof filter[key] === 'object' && !(Array.isArray(filter[key]))) /* This case for Object, Limit 2 nested object  */ {
      const prefix = `${initialPrefix}${key}`;
      Object.entries(filter[key]).forEach(([nextKey, elm]: any[]) => {
        if (typeof elm === 'object' && !(Array.isArray(elm))) result = filterValueToQuery(elm, `${prefix}[${nextKey}]`); // timespan
        // if not just added;
        result = `${result}&${prefix}[${nextKey}]=${elm}`;
      });
    } else if (value !== null && value !== '' && value !== undefined) {
      if (initialPrefix) result = `${result}&${initialPrefix}[${key}]=${value}`;
      else result = `${result}&${key}=${value}`;
    }
  });
  return result;
}

function getPDFReport(report: string, key: number | string, filter: any = null) {
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', `Bearer ${localStorage.getItem('tms-admin-apollo-token')}`);

  const file = `${process.env.VUE_APP_BACKEND_HTTP}/api/report/${report}/${key}?${filterValueToQuery(filter)}`;

  fetch(file, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `[${useFormat.date().computerShortDate()}]-TMS-Report-${report}-${key}`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
}

function getCSVReport(route: string, filter: any) {
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', `Bearer ${localStorage.getItem('tms-admin-apollo-token')}`);

  const file = `${process.env.VUE_APP_BACKEND_HTTP}/api/reports/${route}?${filterValueToQuery(filter)}`;

  fetch(file, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `[${useFormat.date().computerShortDate()}]-TMS-Report-${route}`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
}

function getRawDataReport(report: string, filter: any = null, fileName = 'deliveries') {
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', `Bearer ${localStorage.getItem('tms-admin-apollo-token')}`);
  headers.append('Content-Type', 'application/json');

  const file = `${process.env.VUE_APP_BACKEND_HTTP}/api/report/${report}`;

  fetch(file, {
    headers,
    method: 'POST',
    body: JSON.stringify(filter),
  })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `${useFormat.date().dayjs.format('YYYY-MM-DD HH:mm')}-TMS-${fileName}`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
}

export default function useDownloadReport() {
  return {
    getPDFReport,
    getCSVReport,
    getRawDataReport,
  };
}
